import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { ISubscription } from 'rxjs-compat/Subscription';
import { environment } from '../../../../environments/environment';
import { ToastrMessagesService } from '../../../shared/services/toastr-messages.service';


@Component({
  selector: 'app-selezionecuaa',
  templateUrl: './selezionecuaa.component.html',
  styleUrls: ['./selezionecuaa.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelezionecuaaComponent implements OnInit {

  isFascicolo = true;

  aziendeAssociate = new Array<any>();
  listaAziendeAssociate = new Array<any>();
  subscriptionUserLogin: ISubscription;
  userLogin: any;
  collapsed = true;
  ruolo;
  codiceFiscale;
  aziendaFormGroup = this.fb.group({
    azienda: ['', Validators.required],

  })

  constructor(private authService: AuthService, 
    private cookieService: CookieService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private fb: FormBuilder, 
    private location: LocationStrategy,
    private toastr: ToastrMessagesService) {

    this.location.onPopState(() => {
      this.router.navigate(['/menu'])
    })

  }
  

  get azienda() {
    return this.aziendaFormGroup.get("azienda");
  } 

  ngOnInit() {
    this.userLogin = JSON.parse(sessionStorage.getItem("user")!);
    if (this.userLogin['idRuolo'] == 0) {
      this.ruolo = true;
    }
    this.codiceFiscale = this.userLogin['codiceFiscale'];
    this.listaAziendeAssociate = this.userLogin.aziendeDelegate[0].aziendeDelegate;
  }

  goToApplicativo() {
    if (this.aziendaFormGroup.status == "VALID") {
      this.userLogin['cuaa'] = this.azienda.value.cuaa;
      sessionStorage.setItem('userLogin', this.userLogin);
      sessionStorage.setItem('cuaaSelezionato', this.azienda.value.cuaa);
      sessionStorage.setItem('denominazioneCuaa', this.azienda.value.denominazione);
      this.router.navigate(['/fascicolo/anagrafica'])
    } else {
       this.toastr.showWarnMessage("selezionare un'azienda")
    }
  }

  goTo(nome: String) {
    if (nome == 'cisia') {
      window.location.href = environment.cisia;
    }else {
      this.router.navigate(['/menu']);
    }
  }

  logout() {
    // this.authService.clearSession();
    // this.cookieService.deleteAll();
    window.location.href = environment.cisia;
  }

  

}
